// extracted by mini-css-extract-plugin
export default {"desktopNavigation":"Ym6io","primaryNav":"NJVTT","navigation":"Fuz6d"};